import { localStorageUtils, SDK_CONSTANTS, IAgGridTblPayload } from 'fso-fincrime-sdk-ui';
import { createContext } from 'react';

const TaskListContext = createContext<IAgGridTblPayload>(
  localStorageUtils.getSavedItem(SDK_CONSTANTS.LOCAL_STORAGE_KEYS.TASK_LIST_PAYLOAD)
);

export default TaskListContext;
